import { message } from 'antd';

export default {
  catchApiError: (result, routing) => {
    return new Promise((resolve, reject) => {
      if (result.status === 'false') {
        message.config({
          top: 24,
        });
        if (result.error === 402 || result.error === 403) {
          message.error("登录超时，请重新登录！");
          !!localStorage.me && localStorage.removeItem('me');
          routing.push('/login');
        } else if (typeof result.error === 'object' && result.error.indexOf(402) >= 0) {
          message.error("登录超时，请重新登录！");
          !!localStorage.me && localStorage.removeItem('me');
          routing.push('/login');
        } else {
          result.msg && message.error(result.msg);
          reject(result);
        }
        return;
      }
      resolve(result);
    });
  },
  transHTML(val = "") {
    let result = val
      .replace(/>/g, "&gt;")
      .replace(/</g, "&lt;")
      .replace(/\n/g, "<br/>")
      .replace(/\r/g, "<br/>")
      .replace(/\s/g, "&nbsp;")
      .replace(/'/g, "&apos;")
      .replace(/"/g, "&quot;");
    return result;
  },
  getAccessToken: () => {
    let access_token = '';
    if (!!localStorage.me) {
      let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
      access_token = me.token.access_token;
    }
    return access_token;
  },
  getMobile: () => {
    let mobile = '';
    if (!!localStorage.me) {
      let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "", member: {} };
      mobile = me.member.m_mobile;
    }
    return mobile;
  },
  getEcId: () => {
    let ecId = '';
    if (!!localStorage.me) {
      let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
      if (me.member) ecId = me.member.ec_id;
    }
    return ecId;
  },
  getParams: (params = {}) => {
    const res = {};
    Object.keys(params).forEach(v => {
      if (params[v]) res[v] = params[v];
    });
    return res;
  },
  getPermissions: () => {
    if (!localStorage.me) return true;
    let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
    return me.member && me.member.r_id && me.member.r_id <= 70;
  },
  getFileIds: (files = []) => {
    return files.map(v => v.response ? v.response.id : v.uid);
  },
  getRcId: () => {
    let rId = '';
    if (!!localStorage.me) {
      let me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
      if (me.member) rId = me.member.r_id;
    }
    return parseInt(rId, 10);
  },
}


// WEBPACK FOOTER //
// ./src/util/index.js